import { Button, Dialog, DialogContent, DialogTitle } from '@e2n/ui';
import { toast } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useApiAktivierung } from '../hooks/useApiAktivierung';
import { useVertragAuswahl } from '../hooks/useVertragAuswahl';
import { VertragAuswahl } from './VertragAuswahl';

type AktivierenDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AktivierenDialog({
  open,
  onOpenChange,
}: AktivierenDialogProps) {
  const { t } = useTranslation();
  const { aktiviere, loading } = useApiAktivierung();
  const { vertraege, vertrag, waehle, laedt, keinVertrag } =
    useVertragAuswahl(open);

  async function handleConfirm() {
    if (!vertrag) {
      return;
    }

    if (await aktiviere(vertrag.vertragsnummer)) {
      onOpenChange(false);
      return;
    }

    toast({
      variant: 'error',
      title: t('domain.e2nApi.aktivierung.dialog.fehler'),
    });
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-6 p-8 sm:max-w-[444px]">
        <DialogTitle>{t('domain.e2nApi.aktivierung.dialog.title')}</DialogTitle>

        <div className="text-sm text-neutrals-900">
          {t('domain.e2nApi.aktivierung.dialog.description')}
        </div>

        {keinVertrag ? (
          <div className="text-sm text-neutrals-900">
            {t('domain.e2nApi.aktivierung.dialog.keinVertrag')}
          </div>
        ) : (
          <VertragAuswahl
            vertraege={vertraege}
            vertrag={vertrag}
            laedt={laedt}
            onWaehle={waehle}
          />
        )}

        <div className="flex items-center justify-end gap-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('domain.e2nApi.aktivierung.dialog.abbrechen')}
          </Button>
          <Button onClick={handleConfirm} disabled={loading || !vertrag}>
            {t('domain.e2nApi.aktivierung.dialog.bestaetigen')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
